module.exports = __webpack_public_path__ + "assets/img/IMG041.97984e50.png";